import React from 'react'
import PropTypes from 'prop-types'

function TermsTable({terms, onEdit, onDelete}) {
  return <table className='table'>
    <thead>
      <tr>
        <th>Name</th>
        <th>Terms text</th>
        <th>Link to full terms document/website</th>
        <th className='modify'>Modify</th>
      </tr>
    </thead>
    <tbody>
      { 
        terms.map((term, index) => {
          return <tr key={index}>
            <td>{term.name}</td>
            <td>{term.text}</td>
            <td>{term.url}</td>
            <td>
              <div className='menu-buttons'>
                <button className='btn btn-primary' onClick={() => onEdit(term)}>Edit</button>
                <button className='btn btn-danger' onClick={() => onDelete(term)}>Delete</button>
              </div>
            </td>
          </tr>
        })
      }
    </tbody>
  </table>
}

TermsTable.propTypes = {
  terms: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default TermsTable
